import { combineEpics } from 'redux-observable';

import fetchTransportationAmenitiesContentEpic from './fetchTransportationAmenitiesContent.epic';

export default combineEpics(fetchTransportationAmenitiesContentEpic);
